import React from "react"
import { Row, Col, Card, CardDeck } from "react-bootstrap"
import {navigate} from 'gatsby'

import {
  LineChart, Line, AreaChart, Area, ResponsiveContainer, BarChart, Bar, XAxis, YAxis
} from 'recharts'
import styles from './front.module.css'

const TinyLineChart = () => {
  const data = [{point: 20}, {point: 40}, {point: 80}, {point: 100}, {point: 80}, {point: 140}, {point: 160}]  

  return (
    <ResponsiveContainer width="100%" height={150}>
      <LineChart data={data} cursor='pointer'>
        <Line type="monotone" dataKey="point" stroke="#8884d8" strokeWidth={4} />
      </LineChart>
    </ResponsiveContainer>
  )
}

const TinyAreaChart = () => {
  const data = [{point: 10}, {point: 40}, {point: 80}, {point: 160}, {point: 456}, {point: 798}, {point: 1500}]

  return (
    <ResponsiveContainer width="100%" height={150}>
      <AreaChart
        data={data}
        margin={{
          top: 5, right: 0, left: 0, bottom: 20,
        }}
        cursor='pointer'
      >
        <Area type="monotone" dataKey="point" stroke="#8884d8" fill="#8884d8" />
      </AreaChart>
    </ResponsiveContainer>
  )
}

const TinyBarChart = () => {
  const data = [{monthly: 5, yearly: 46}]

  return (
    <ResponsiveContainer width="100%" height={150}>
      <BarChart data={data} layout='vertical' cursor='pointer'>
        <XAxis type='number' hide='true'/>
        <YAxis type="category" hide='true'/>
        <Bar dataKey='monthly' fill='#8884d8'/>
        <Bar dataKey="yearly" fill="#82ca9d" />
      </BarChart>
    </ResponsiveContainer>
  )
}

const Front = () => (
  <Row>
    <Col>
      <CardDeck>
        <Card onClick={()=>{navigate("/compoundchurn")}} className={styles.card}>
          <Card.Body>
            <TinyAreaChart />
            <Card.Title>Compound effect of monthly Churn</Card.Title>
            <Card.Text>
              Each customer who churns is a opportunity lost. Use this model to understand how much money you could save by reducing your churn.
            </Card.Text>
            <Card.Link href="/saas-metrics/compoundchurn">Explore model</Card.Link>
          </Card.Body>
        </Card>
        <Card className={styles.card} onClick={()=>{navigate("/monthlytoyearly")}}>
          <Card.Body>
            <TinyBarChart />
            <Card.Title>Monthly Churn to Yearly Churn</Card.Title>
            <Card.Text>
              Explore how your monthly churn converts to yearly. Did you know that 5% monthly churn equals to about 46% yearly?
            </Card.Text>
            <Card.Link href="/saas-metrics/monthlytoyearly">Explore model</Card.Link>
          </Card.Body>
        </Card>
        <Card className={styles.card} onClick={()=>{navigate("/growthestimation")}}>
          <Card.Body>
            <TinyLineChart />
            <Card.Title>Growth estimation</Card.Title>
            <Card.Text>
              Quickly estimate how many demos or trials you have to get to achieve desired growth and how long will it take.
            </Card.Text>
            <Card.Link href="/saas-metrics/growthestimation">Explore model</Card.Link>
          </Card.Body>
        </Card>
      </CardDeck>
    </Col>
  </Row>
)

export default Front
